<template>
  <Teleport to="body">
    <div class="toast-container">
      <TransitionGroup name="toast">
        <div v-for="toast in toasts" :key="toast.id"
             :class="`toast toast-${toast.type}`"
             @click="remove(toast.id)">
          <span class="toast-icon">
            <img v-if="toast.type === 'warning'" src="@/assets/icons/warning_white.png" style="width:16px;height:16px;object-fit:contain;vertical-align:middle"/>
            <template v-else>{{ icons[toast.type] }}</template>
          </span>
          <span class="toast-msg">{{ toast.message }}</span>
          <button class="toast-close">✕</button>
        </div>
      </TransitionGroup>
    </div>
  </Teleport>
</template>

<script setup>
import { useToast } from '@/composables/useToast.js';
const { toasts, remove } = useToast();
const icons = { success: '✓', error: '✕', info: 'ℹ' };
</script>

<style scoped>
.toast-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 10px;
  pointer-events: none;
}
.toast {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 16px;
  border-radius: var(--radius);
  /*background: var(--bg-card);*/
  border: 1px solid var(--border);
  box-shadow: var(--shadow-dropdown);
  min-width: 280px;
  max-width: 400px;
  cursor: pointer;
  pointer-events: all;
  font-size: 13.5px;
}
[data-theme="light"] .toast { background: white; }
[data-theme="dark"] .toast { background: black; }
.toast-success { border-left: 3px solid var(--success); }
.toast-error   { border-left: 3px solid var(--danger);  }
.toast-warning { border-left: 3px solid var(--warning); }
.toast-info    { border-left: 3px solid var(--info);    }
.toast-icon    { font-size: 15px; flex-shrink: 0; }
.toast-success .toast-icon { color: var(--success); }
.toast-error   .toast-icon { color: var(--danger);  }
.toast-warning .toast-icon { color: var(--warning); }
.toast-info    .toast-icon { color: var(--info);    }
.toast-msg     { flex: 1; line-height: 1.4; }
.toast-close   { background: none; border: none; color: var(--text-muted); cursor: pointer; font-size: 12px; padding: 0; flex-shrink: 0; }
.toast-enter-active { transition: all 0.25s ease; }
.toast-leave-active { transition: all 0.2s ease; }
.toast-enter-from   { opacity: 0; transform: translateX(30px); }
.toast-leave-to     { opacity: 0; transform: translateX(30px); }
</style>